import { Select } from "@components/ui-kit/Select";
import classNames from "classnames";
import styles from "./styles.module.scss";

export type SelectOption = { id: string; text: string };

interface FormSelectWrapperProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  options: SelectOption[];
  className?: string;
  placeholder?: string;
  optional?: boolean;
}

export const FormSelectWrapper = ({
  label,
  value,
  onChange,
  options,
  className,
  placeholder,
  optional,
}: FormSelectWrapperProps) => (
  <div className={styles.selectGroup}>
    <label className={styles.label}>
      {label} {optional && <span className={styles.optional}>(optional)</span>}
    </label>
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      className={classNames(
        className,
        value.length === 0 ? styles.selector : undefined,
      )}
    />
  </div>
);
